import { Alert, AlertTitle, Grid, Paper } from '@mui/material';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useTranslation } from 'react-i18next';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useEffect, useState } from 'react';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import SearchField from 'src/shared/components/form/searchField';
import { InvoiceGroups } from 'src/shared/components/form/invoiceGroups';
import { AdminInvoiceTemplateDataGrid } from '../components/adminInvoiceTemplateDataGrid';
import AdminInvoiceTabNavigation from '../components/adminInvoiceTabNavigation';
import { AdminInvoiceTemplateSearchFilter } from '../models/adminInvoiceTemplateSearchFilter';

export const AdminInvoiceTemplateOverviewPage = () => {
  const { t } = useTranslation(['invoice']);
  const isMounted = useIsMounted();

  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);
  const [adminInvoiceTemplateSearchFilter, setAdminInvoiceTemplateSearchFilter] = useState<AdminInvoiceTemplateSearchFilter>({
    searchString: '',
    ownerId: 0,
  });

  const searchFilter: AdminInvoiceTemplateSearchFilter = {
    searchString: adminInvoiceTemplateSearchFilter.searchString,
    ownerId: adminInvoiceTemplateSearchFilter.ownerId,
  };

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setAdminInvoiceTemplateSearchFilter((prev) => ({ ...prev, ...{ searchString: '' } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setAdminInvoiceTemplateSearchFilter((prev) => ({ ...prev, ...{ searchString: tempSearchString } }));
      } else {
        setAdminInvoiceTemplateSearchFilter((prev) => ({ ...prev, ...{ searchString: '' } }));
      }
    }
  }, [isMounted, searchInitialized, setAdminInvoiceTemplateSearchFilter, tempSearchString]);

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <MainContentHeader title={t('invoice:adminInvoiceTemplatePage.pageHeader')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <AdminInvoiceTabNavigation />
          <PageFilterSection
            leftContent={
              <SearchField
                initialValue={searchFilter.searchString || ''}
                disabled={!searchFilter.ownerId || searchFilter.ownerId === 0}
                onSearch={(newSearchString) => {
                  setSearchInitialized(true);
                  setTempSearchString(newSearchString);
                }}
              />
            }
            rightContent={
              <InvoiceGroups
                emptyLabel={t('common:button.choose')}
                placeholder={t('common:button.choose')}
                callback={(ownId) => {
                  setAdminInvoiceTemplateSearchFilter((prev) => ({ ...prev, ...{ ownerId: ownId } }));
                }}
                autoSelect
                ownerId={searchFilter.ownerId}
              />
            }
          />
          {!!searchFilter.ownerId && searchFilter.ownerId > 0 && <AdminInvoiceTemplateDataGrid searchFilter={searchFilter} />}
          {(!searchFilter.ownerId || searchFilter.ownerId === 0) && (
            <Alert severity='info'>
              <AlertTitle>{t('invoice:transactionPage.selectOwnerIdWarningTitle')}</AlertTitle>
              {t('invoice:transactionPage.selectOwnerIdWarningText')}
            </Alert>
          )}
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
